<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
		<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<el-select
				  class="sku-select"
				  v-model="filters.itemNumber"
				  filterable
				  remote
				  :remote-method="(query) => searchItems(query)"
				  :placeholder="$t('TOrderDetail.itemNumber')"
				  clearable
				  @clear="searchItems('')"
				  @visible-change="(visible) => { if (visible) searchItems('') }"
				  @change="findPage(null)"
				  style="width:200px">
				  <el-option
				    v-for="item in itemOptions"
				    :key="item.itemNumber"
				    :value="item.itemNumber"
				    :label="item.itemNumber + ' - ' + (item.description || '')">
				  </el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<kt-button :label="$t('action.add')" perms="sys:tOrder:add" type="primary" icon="el-icon-plus" @click="handleAdd" />
			</el-form-item>
		</el-form>
		</div>
	</div>
		<!--表格内容栏-->
	<kt-table permsEdit="sys:tOrder:edit" permsDelete="sys:tOrder:delete" permsView="sys:tOrder:view"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')" :pageNum=this.pageRequest.pageNum :pageSize=this.pageRequest.pageSize
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="100px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item label="" prop="id"  v-if="false">
				<el-input v-model="dataForm.id" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="orderId"  v-if="false">
				<el-input v-model="dataForm.orderId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemMasterId"  v-if="false">
				<el-input v-model="dataForm.itemMasterId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.whId')" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.orderNumber')" prop="orderNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.orderNumber" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.lineNumber')" prop="lineNumber"  v-if="this.lineNumberVisible">
				<el-input v-model="dataForm.lineNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.itemNumber')" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
			<el-select ref="itemNumber" v-model="dataForm.itemNumber" style="width:100%" class="sku-select" filterable remote :remote-method="searchEditSkus" clearable @clear="searchEditSkus('')">
			<el-option v-for="(sku,index) in this.editSkuOptions" :key="index" :value="sku.optionValue"
						:label="sku.optionDisplay" @click.native="getItemBaseUom"/>
			</el-select>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.lotNumber')" prop="lotNumber"  v-if="this.lotControl==='Y'">
				<el-input v-model="dataForm.lotNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item  :label="$t('TOrderDetail.qty')" prop="qty"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.qty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.orderUom')" prop="orderUom"  v-if="!dataForm.isPrimaryKey">
				<el-select ref="orderUom" v-model="dataForm.orderUom" style="width:100%">
				<el-option v-for="(uom,index) in this.baseUomData" :key="index" :value="uom.optionValue"
							:label="uom.optionDisplay"/>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('TOrderDetail.holdReasonId')" prop="holdReasonId"  v-if="true">
				<el-select ref="holdReasonId" v-model="dataForm.holdReasonId" style="width:100%">
				<!-- <el-option :label="$t('TOrder.option.any')" value=""></el-option> -->
				<el-option v-for="(reason,index) in this.reasonData" :key="index" :value="reason.optionValue"
							:label="reason.optionDisplay"/>
				</el-select>
		 	</el-form-item>
			<el-form-item label="" prop="storedAttributeId"  v-if="false">
				<el-input v-model="dataForm.storedAttributeId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow1')" prop="genericAttrShow1" v-if="this.attributesCount>0">
				<el-input v-model="dataForm.genericAttrShow1" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue1" v-if="this.attributesCount>0">
				<el-input v-model="dataForm.genericAttrValue1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow2')" prop="genericAttrShow2" v-if="this.attributesCount>1">
				<el-input v-model="dataForm.genericAttrShow2" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue2" v-if="this.attributesCount>1">
				<el-input v-model="dataForm.genericAttrValue2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow3')" prop="genericAttrShow3" v-if="this.attributesCount>2">
				<el-input v-model="dataForm.genericAttrShow3" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue3" v-if="this.attributesCount>2">
				<el-input v-model="dataForm.genericAttrValue3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow4')" prop="genericAttrShow4" v-if="this.attributesCount>3">
				<el-input v-model="dataForm.genericAttrShow4" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue4" v-if="this.attributesCount>3">
				<el-input v-model="dataForm.genericAttrValue4" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow5')" prop="genericAttrShow5" v-if="this.attributesCount>4">
				<el-input v-model="dataForm.genericAttrShow5" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue5" v-if="this.attributesCount>4">
				<el-input v-model="dataForm.genericAttrValue5" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow6')" prop="genericAttrShow6" v-if="this.attributesCount>5">
				<el-input v-model="dataForm.genericAttrShow6" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue6" v-if="this.attributesCount>5">
				<el-input v-model="dataForm.genericAttrValue6" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow7')" prop="genericAttrShow7" v-if="this.attributesCount>6">
				<el-input v-model="dataForm.genericAttrShow7" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue7" v-if="this.attributesCount>6">
				<el-input v-model="dataForm.genericAttrValue7" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow8')" prop="genericAttrShow8" v-if="this.attributesCount>7">
				<el-input v-model="dataForm.genericAttrShow8" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue8" v-if="this.attributesCount>7">
				<el-input v-model="dataForm.genericAttrValue8" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow9')" prop="genericAttrShow9" v-if="this.attributesCount>8">
				<el-input v-model="dataForm.genericAttrShow9" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue9" v-if="this.attributesCount>8">
				<el-input v-model="dataForm.genericAttrValue9" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow10')" prop="genericAttrShow10" v-if="this.attributesCount>9">
				<el-input v-model="dataForm.genericAttrShow10" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue10" v-if="this.attributesCount>9">
				<el-input v-model="dataForm.genericAttrValue10" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('attributes.genericAttrShow11')" prop="genericAttrShow11" v-if="this.attributesCount>10">
				<el-input v-model="dataForm.genericAttrShow11" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item label="" prop="genericAttrValue11" v-if="this.attributesCount>10">
				<el-input v-model="dataForm.genericAttrValue11" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="boQty"  v-if="false">
				<el-input v-model="dataForm.boQty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="boDescription"  v-if="false">
				<el-input v-model="dataForm.boDescription" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="boWeight"  v-if="false">
				<el-input v-model="dataForm.boWeight" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="afoPlanQty"  v-if="false">
				<el-input v-model="dataForm.afoPlanQty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="unitPack"  v-if="false">
				<el-input v-model="dataForm.unitPack" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemWeight"  v-if="false">
				<el-input v-model="dataForm.itemWeight" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemTareWeight"  v-if="false">
				<el-input v-model="dataForm.itemTareWeight" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="hazMaterial"  v-if="false">
				<el-input v-model="dataForm.hazMaterial" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLClass"  v-if="false">
				<el-input v-model="dataForm.bOLClass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLLine1"  v-if="false">
				<el-input v-model="dataForm.bOLLine1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLLine2"  v-if="false">
				<el-input v-model="dataForm.bOLLine2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLLine3"  v-if="false">
				<el-input v-model="dataForm.bOLLine3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLPlacCode"  v-if="false">
				<el-input v-model="dataForm.bOLPlacCode" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLPlacDesc"  v-if="false">
				<el-input v-model="dataForm.bOLPlacDesc" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="bOLCode"  v-if="false">
				<el-input v-model="dataForm.bOLCode" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="qtyShipped"  v-if="false">
				<el-input v-model="dataForm.qtyShipped" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="lineType"  v-if="false">
				<el-input v-model="dataForm.lineType" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemDescription"  v-if="false">
				<el-input v-model="dataForm.itemDescription" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="stackingSeq"  v-if="false">
				<el-input v-model="dataForm.stackingSeq" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="custPart"  v-if="false">
				<el-input v-model="dataForm.custPart" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickingFlow"  v-if="false">
				<el-input v-model="dataForm.pickingFlow" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="unitWeight"  v-if="false">
				<el-input v-model="dataForm.unitWeight" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="unitVolume"  v-if="false">
				<el-input v-model="dataForm.unitVolume" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="extendedWeight"  v-if="false">
				<el-input v-model="dataForm.extendedWeight" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="extendedVolume"  v-if="false">
				<el-input v-model="dataForm.extendedVolume" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="overAllocQty"  v-if="false">
				<el-input v-model="dataForm.overAllocQty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="dateExpected"  v-if="false">
				<el-input v-model="dataForm.dateExpected" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="hostWaveId"  v-if="false">
				<el-input v-model="dataForm.hostWaveId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="tranPlanQty"  v-if="false">
				<el-input v-model="dataForm.tranPlanQty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="useShippableUom"  v-if="false">
				<el-input v-model="dataForm.useShippableUom" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="unitInsuranceAmount"  v-if="false">
				<el-input v-model="dataForm.unitInsuranceAmount" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="holdReasonId"  v-if="false">
				<el-input v-model="dataForm.holdReasonId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="originalOrderNumber"  v-if="false">
				<el-input v-model="dataForm.originalOrderNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="originalLineNumber"  v-if="false">
				<el-input v-model="dataForm.originalLineNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MClientPoNumber"  v-if="false">
				<el-input v-model="dataForm.MClientPoNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MReferenceQty"  v-if="false">
				<el-input v-model="dataForm.MReferenceQty" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MCustomerItemNumber"  v-if="false">
				<el-input v-model="dataForm.MCustomerItemNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MVasProfileCode"  v-if="false">
				<el-input v-model="dataForm.MVasProfileCode" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericDate1"  v-if="false">
				<el-input v-model="dataForm.MGenericDate1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericDate2"  v-if="false">
				<el-input v-model="dataForm.MGenericDate2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericDate3"  v-if="false">
				<el-input v-model="dataForm.MGenericDate3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericQty1"  v-if="false">
				<el-input v-model="dataForm.MGenericQty1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericQty2"  v-if="false">
				<el-input v-model="dataForm.MGenericQty2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericQty3"  v-if="false">
				<el-input v-model="dataForm.MGenericQty3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField1"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField2"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField3"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField4"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField4" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField5"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField5" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericAlloField6"  v-if="false">
				<el-input v-model="dataForm.MGenericAlloField6" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericField1"  v-if="false">
				<el-input v-model="dataForm.MGenericField1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericField2"  v-if="false">
				<el-input v-model="dataForm.MGenericField2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericField3"  v-if="false">
				<el-input v-model="dataForm.MGenericField3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericField4"  v-if="false">
				<el-input v-model="dataForm.MGenericField4" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MGenericField5"  v-if="false">
				<el-input v-model="dataForm.MGenericField5" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MDynamicField1"  v-if="false">
				<el-input v-model="dataForm.MDynamicField1" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MDynamicField2"  v-if="false">
				<el-input v-model="dataForm.MDynamicField2" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MDynamicField3"  v-if="false">
				<el-input v-model="dataForm.MDynamicField3" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MDynamicField4"  v-if="false">
				<el-input v-model="dataForm.MDynamicField4" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MDynamicField5"  v-if="false">
				<el-input v-model="dataForm.MDynamicField5" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MCreatedBy"  v-if="false">
				<el-input v-model="dataForm.MCreatedBy" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MCreatedDate"  v-if="false">
				<el-input v-model="dataForm.MCreatedDate" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MUpdatedBy"  v-if="false">
				<el-input v-model="dataForm.MUpdatedBy" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MUpdatedDate"  v-if="false">
				<el-input v-model="dataForm.MUpdatedDate" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TOrderDetail',
	components:{
		KtTable,
		KtButton
	},
	data() {
	return {
		size: 'small',
		baseUomData:Object,
		skuData:Object,
		editSkuOptions: [],
		reasonData:Object,
		lotControl:'',
		clientCode:'',
		attributesCount:0,
		lineNumberVisible: false, // 行号是否显示
		filters: {
			orderNumber: '',
        	whId: '',
        	itemNumber: ''
		},
		columns: [
			{prop:"id", label:"TOrderDetail.id", minWidth:100},
			{prop:"whId", label:"TOrderDetail.whId", minWidth:100},
			{prop:"orderNumber", label:"TOrderDetail.orderNumber", minWidth:100},
			{prop:"lineNumber", label:"TOrderDetail.lineNumber", minWidth:100},
			{prop:"itemNumber", label:"TOrderDetail.itemNumber", minWidth:100},
			{prop:"description", label:"common.itemDescription", minWidth:120},
			{prop:"lotNumber", label:"TOrderDetail.lotNumber", minWidth:100},
			{prop:"qty", label:"TOrderDetail.qty", minWidth:100},
			{prop:"orderUom", label:"TOrderDetail.orderUom", minWidth:100},
			{prop:"holdReasonId", label:"TOrderDetail.holdReasonId", minWidth:100},
			{prop:"storedAttributeId", label:"TOrderDetail.storedAttributeId", minWidth:100},
			{prop:"genericAttrValue1", label:"attributes.genericAttrValue1", minWidth:100, display:false},
			{prop:"genericAttrValue2", label:"attributes.genericAttrValue2", minWidth:100, display:false},
			{prop:"genericAttrValue3", label:"attributes.genericAttrValue3", minWidth:100, display:false},
			{prop:"genericAttrValue4", label:"attributes.genericAttrValue4", minWidth:100, display:false},
			{prop:"genericAttrValue5", label:"attributes.genericAttrValue5", minWidth:100, display:false},
			{prop:"genericAttrValue6", label:"attributes.genericAttrValue6", minWidth:100, display:false},
			{prop:"genericAttrValue7", label:"attributes.genericAttrValue7", minWidth:100, display:false},
			{prop:"genericAttrValue8", label:"attributes.genericAttrValue8", minWidth:100, display:false},
			{prop:"genericAttrValue9", label:"attributes.genericAttrValue9", minWidth:100, display:false},
			{prop:"genericAttrValue10", label:"attributes.genericAttrValue10", minWidth:100, display:false},
			{prop:"genericAttrValue11", label:"attributes.genericAttrValue11", minWidth:100, display:false},
			{prop:"genericAttrShow1", label:"attributes.genericAttrShow1", minWidth:100},
			{prop:"genericAttrShow2", label:"attributes.genericAttrShow2", minWidth:100},
			{prop:"genericAttrShow3", label:"attributes.genericAttrShow3", minWidth:100},
			{prop:"genericAttrShow4", label:"attributes.genericAttrShow4", minWidth:100},
			{prop:"genericAttrShow5", label:"attributes.genericAttrShow5", minWidth:100},
			{prop:"genericAttrShow6", label:"attributes.genericAttrShow6", minWidth:100},
			{prop:"genericAttrShow7", label:"attributes.genericAttrShow7", minWidth:100},
			{prop:"genericAttrShow8", label:"attributes.genericAttrShow8", minWidth:100},
			{prop:"genericAttrShow9", label:"attributes.genericAttrShow9", minWidth:100},
			{prop:"genericAttrShow10", label:"attributes.genericAttrShow10", minWidth:100},
			{prop:"genericAttrShow11", label:"attributes.genericAttrShow11", minWidth:100},
			// {prop:"orderId", label:"", minWidth:100},
			// {prop:"itemMasterId", label:"", minWidth:100},
			// {prop:"boQty", label:"", minWidth:100},
			// {prop:"boDescription", label:"", minWidth:100},
			// {prop:"boWeight", label:"", minWidth:100},
			// {prop:"afoPlanQty", label:"", minWidth:100},
			// {prop:"unitPack", label:"", minWidth:100},
			// {prop:"itemWeight", label:"", minWidth:100},
			// {prop:"itemTareWeight", label:"", minWidth:100},
			// {prop:"hazMaterial", label:"", minWidth:100},
			// {prop:"bOLClass", label:"", minWidth:100},
			// {prop:"bOLLine1", label:"", minWidth:100},
			// {prop:"bOLLine2", label:"", minWidth:100},
			// {prop:"bOLLine3", label:"", minWidth:100},
			// {prop:"bOLPlacCode", label:"", minWidth:100},
			// {prop:"bOLPlacDesc", label:"", minWidth:100},
			// {prop:"bOLCode", label:"", minWidth:100},
			// {prop:"qtyShipped", label:"", minWidth:100},
			// {prop:"lineType", label:"", minWidth:100},
			// {prop:"itemDescription", label:"", minWidth:100},
			// {prop:"stackingSeq", label:"", minWidth:100},
			// {prop:"custPart", label:"", minWidth:100},
			// {prop:"pickingFlow", label:"", minWidth:100},
			// {prop:"unitWeight", label:"", minWidth:100},
			// {prop:"unitVolume", label:"", minWidth:100},
			// {prop:"extendedWeight", label:"", minWidth:100},
			// {prop:"extendedVolume", label:"", minWidth:100},
			// {prop:"overAllocQty", label:"", minWidth:100},
			// {prop:"dateExpected", label:"", minWidth:100},
			// {prop:"hostWaveId", label:"", minWidth:100},
			// {prop:"tranPlanQty", label:"", minWidth:100},
			// {prop:"useShippableUom", label:"", minWidth:100},
			// {prop:"unitInsuranceAmount", label:"", minWidth:100},
			// {prop:"originalOrderNumber", label:"", minWidth:100},
			// {prop:"originalLineNumber", label:"", minWidth:100},
			// {prop:"MClientPoNumber", label:"", minWidth:100},
			// {prop:"MReferenceQty", label:"", minWidth:100},
			// {prop:"MCustomerItemNumber", label:"", minWidth:100},
			// {prop:"MVasProfileCode", label:"", minWidth:100},
			// {prop:"MGenericDate1", label:"", minWidth:100},
			// {prop:"MGenericDate2", label:"", minWidth:100},
			// {prop:"MGenericDate3", label:"", minWidth:100},
			// {prop:"MGenericQty1", label:"", minWidth:100},
			// {prop:"MGenericQty2", label:"", minWidth:100},
			// {prop:"MGenericQty3", label:"", minWidth:100},
			// {prop:"MGenericAlloField1", label:"", minWidth:100},
			// {prop:"MGenericAlloField2", label:"", minWidth:100},
			// {prop:"MGenericAlloField3", label:"", minWidth:100},
			// {prop:"MGenericAlloField4", label:"", minWidth:100},
			// {prop:"MGenericAlloField5", label:"", minWidth:100},
			// {prop:"MGenericAlloField6", label:"", minWidth:100},
			// {prop:"MGenericField1", label:"", minWidth:100},
			// {prop:"MGenericField2", label:"", minWidth:100},
			// {prop:"MGenericField3", label:"", minWidth:100},
			// {prop:"MGenericField4", label:"", minWidth:100},
			// {prop:"MGenericField5", label:"", minWidth:100},
			// {prop:"MDynamicField1", label:"", minWidth:100},
			// {prop:"MDynamicField2", label:"", minWidth:100},
			// {prop:"MDynamicField3", label:"", minWidth:100},
			// {prop:"MDynamicField4", label:"", minWidth:100},
			// {prop:"MDynamicField5", label:"", minWidth:100},
			// {prop:"MCreatedBy", label:"", minWidth:100},
			// {prop:"MCreatedDate", label:"", minWidth:100},
			// {prop:"MUpdatedBy", label:"", minWidth:100},
			// {prop:"MUpdatedDate", label:"", minWidth:100},
		],
		pageRequest: { pageNum: 1, pageSize: 1000 },
		pageResult: {},
			itemOptions: [],

		operation: false, // true:新增, false:编辑
		editDialogVisible: false, // 新增编辑界面是否显示
		editLoading: false,
		dataFormRules: {
			qty: [
			{ required: true, message: this.$t('common.dataFormRules.quantityRequired'), trigger: 'blur' },
			{ pattern : /(^[1-9](\d+)?(\.(?!.*0$)\d{1,3})?$)|(^\d\.(?!.*0$)\d{1,3}$)/,message: this.$t('common.dataFormRules.quantityGreaterZeroPattern'), trigger: 'blur' }
			],
			lineNumber: [
			{ required: true, message: this.$t('common.dataFormRules.lineNumberRequired'), trigger: 'blur' },
			{ pattern : /^[1-9]\d*$/,message: this.$t('common.dataFormRules.lineNumberPattern'), trigger: 'blur' }
			],
			itemNumber: [
			{ required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
			],
			orderUom: [
			{ required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
			]
		},
		// 新增编辑界面数据
		dataForm: {
			id: null,
			orderId: null,
			itemMasterId: null,
			whId: null,
			orderNumber: null,
			lineNumber: null,
			itemNumber: null,
			boQty: null,
			boDescription: null,
			boWeight: null,
			qty: null,
			afoPlanQty: null,
			unitPack: null,
			itemWeight: null,
			itemTareWeight: null,
			hazMaterial: null,
			bOLClass: null,
			bOLLine1: null,
			bOLLine2: null,
			bOLLine3: null,
			bOLPlacCode: null,
			bOLPlacDesc: null,
			bOLCode: null,
			qtyShipped: null,
			lineType: null,
			itemDescription: null,
			stackingSeq: null,
			custPart: null,
			lotNumber: null,
			pickingFlow: null,
			unitWeight: null,
			unitVolume: null,
			extendedWeight: null,
			extendedVolume: null,
			overAllocQty: null,
			dateExpected: null,
			orderUom: null,
			hostWaveId: null,
			tranPlanQty: null,
			useShippableUom: null,
			unitInsuranceAmount: null,
			storedAttributeId: null,
			genericAttrValue1: null,
			genericAttrValue2: null,
			genericAttrValue3: null,
			genericAttrValue4: null,
			genericAttrValue5: null,
			genericAttrValue6: null,
			genericAttrValue7: null,
			genericAttrValue8: null,
			genericAttrValue9: null,
			genericAttrValue10: null,
			genericAttrValue11: null,
			genericAttrShow1: null,
			genericAttrShow2: null,
			genericAttrShow3: null,
			genericAttrShow4: null,
			genericAttrShow5: null,
			genericAttrShow6: null,
			genericAttrShow7: null,
			genericAttrShow8: null,
			genericAttrShow9: null,
			genericAttrShow10: null,
			genericAttrShow11: null,
			holdReasonId: null,
			originalOrderNumber: null,
			originalLineNumber: null,
			MClientPoNumber: null,
			MReferenceQty: null,
			MCustomerItemNumber: null,
			MVasProfileCode: null,
			MGenericDate1: null,
			MGenericDate2: null,
			MGenericDate3: null,
			MGenericQty1: null,
			MGenericQty2: null,
			MGenericQty3: null,
			MGenericAlloField1: null,
			MGenericAlloField2: null,
			MGenericAlloField3: null,
			MGenericAlloField4: null,
			MGenericAlloField5: null,
			MGenericAlloField6: null,
			MGenericField1: null,
			MGenericField2: null,
			MGenericField3: null,
			MGenericField4: null,
			MGenericField5: null,
			MDynamicField1: null,
			MDynamicField2: null,
			MDynamicField3: null,
			MDynamicField4: null,
			MDynamicField5: null,
			MCreatedBy: null,
			MCreatedDate: null,
			MUpdatedBy: null,
			MUpdatedDate: null,
			}
		}
	},
	methods: {
    getParentParams: function () {
      this.filters.orderNumber=this.$route.query.orderNumber
      this.filters.whId=this.$route.query.whId
      if (this.filters.whId) sessionStorage.setItem('tod_whId', this.filters.whId)
      if (this.filters.orderNumber) sessionStorage.setItem('tod_orderNumber', this.filters.orderNumber)
	  this.findPage(null)
    },
    //获取商品基本单位
    getItemBaseUom: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber
      let objUom = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemBaseUom(objUom)
        .then(res =>
        {
          //请求返回的数据
          this.baseUomData = res.data
          this.getItemLotCtlAttrCollection()
        })
    },
    //获取SKU下拉列表
    getSku: function (){
      let whId=this.filters.whId
      let objSku = {whId:whId}
      this.$wmsApi.globalOption.getSku(objSku)
        .then(res =>
        {
          //请求返回的数据
          this.skuData = res.data
          this.editSkuOptions = res.data
        })
    },
    //获取商品批号控制和动态属性集合ID
    getItemLotCtlAttrCollection: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber

      let objReq = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemLotCtlAttrCollection(objReq).then(res =>
      {
        //请求返回的数据
        if (JSON.stringify(res.data) !== '[]') {
          this.lotControl = res.data[0]["lotControl"]
		  this.clientCode = res.data[0]["clientCode"]
          let attributeCollectionId = res.data[0]["attributeCollectionId"]
          if (attributeCollectionId!==null) {
            this.getItemAttributeTypes()
          } else {
            this.attributesCount=0
            this.dataForm.storedAttributeId=null
			this.getReason()
          }
        } else {
          this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.notFoundItem"), type: 'error'})
        }
      })
    },
    //获取商品批号控制和动态属性
    getItemAttributeTypes: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber

      let objReq = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemAttributeTypes(objReq).then(res =>
      {
        //请求返回的数据
        if (JSON.stringify(res.data) !== '[]') {
          let rowCount = 0
          for (let i = 0; i < res.data.length; i++) {
            if (i === 0 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow1 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 1 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow2 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 2 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow3 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 3 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow4 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 4 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow5 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 5 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow6 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 6 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow7 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 7 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow8 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 8 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow9 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 9 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow10 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
            if (i === 10 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow11 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
          }
          this.attributesCount = rowCount
		  this.getReason()
        } else {
          this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.notFoundItemAttributes"), type: 'error'})
        }
      })
    },
    // 有动态属性时，必须全部填写或全部为空
    hasEmptyVisibleAttr: function() {
      if (this.attributesCount === 0) return false
      let hasEmpty = false
      let hasFilled = false
      for (let i = 1; i <= this.attributesCount; i++) {
        let val = this.dataForm['genericAttrValue' + i]
        if (val === null || val === '' || val === undefined || String(val).trim() === '') {
          hasEmpty = true
        } else {
          hasFilled = true
        }
      }
      // 禁止部分填写：要么全空，要么全填
      if (hasEmpty && hasFilled) return true
      return false
    },
    // 检测所有可见动态属性是否为空
    areAllVisibleAttrsEmpty: function() {
      if (this.attributesCount === 0) return true
      for (let i = 1; i <= this.attributesCount; i++) {
        let val = this.dataForm['genericAttrValue' + i]
        // null / undefined / "" / "   " 都算空
        if (val !== null && val !== undefined && val !== '' && String(val).trim() !== '') {
          return false
        }
      }
      return true
    },
    // 入口方法：根据动态属性填写状态决定直接保存还是调用接口生成属性ID
    callSaveOrStoredAttributeId: function () {
      // 编辑/添加统一走这里：如果所有可见动态属性都为空，直接保存
      if (this.attributesCount > 0 && this.areAllVisibleAttrsEmpty()) {
        this.dataForm.storedAttributeId = null
        this.save()
        return
      }
      this.getStoredAttributeId()
    },
    getStoredAttributeId: function () {
      if(this.attributesCount>0)
      {
        // 部分填写但未全部填写 → 报错
        if (this.hasEmptyVisibleAttr()) {
          this.$message({message: this.$t("attributes.message.itemAttributesIsEmpty"), type: 'error'})
          return
        }

        let whId=this.dataForm.whId
        let itemNumber=this.dataForm.itemNumber
        let genericAttrValue1=this.dataForm.genericAttrValue1||''
        let genericAttrValue2=this.dataForm.genericAttrValue2||''
        let genericAttrValue3=this.dataForm.genericAttrValue3||''
        let genericAttrValue4=this.dataForm.genericAttrValue4||''
        let genericAttrValue5=this.dataForm.genericAttrValue5||''
        let genericAttrValue6=this.dataForm.genericAttrValue6||''
        let genericAttrValue7=this.dataForm.genericAttrValue7||''
        let genericAttrValue8=this.dataForm.genericAttrValue8||''
        let genericAttrValue9=this.dataForm.genericAttrValue9||''
        let genericAttrValue10=this.dataForm.genericAttrValue10||''
        let genericAttrValue11=this.dataForm.genericAttrValue11||''

		this.dataForm.storedAttributeId=null

        let objReq = {itemNumber:itemNumber,whId:whId,genericAttrValue1:genericAttrValue1,genericAttrValue2:genericAttrValue2,genericAttrValue3:genericAttrValue3,genericAttrValue4:genericAttrValue4,genericAttrValue5:genericAttrValue5,genericAttrValue6:genericAttrValue6,genericAttrValue7:genericAttrValue7,genericAttrValue8:genericAttrValue8,genericAttrValue9:genericAttrValue9,genericAttrValue10:genericAttrValue10,genericAttrValue11:genericAttrValue11}
        this.$wmsApi.globalOption.getStoredAttributeId(objReq).then(res =>{
          //请求返回的数据
          if(res.code == 200)
          {
            if(JSON.stringify(res.data) !== '{}')
            {
              if(res.data["storedAttributeId"]!==null)
              {
                this.dataForm.storedAttributeId=res.data["storedAttributeId"]
				this.save()
              } else {
                this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.generateAttributesFail"),type: 'error'})
              }
            }
            
          } else {
            this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
          }
        })
      } else {
        //如果商品未设置动态属性，则直接保存
        this.save()
      }
    },
	// 获取分页数据
	searchItems(query) {
			if (!this.filters.whId) return
			this.$wmsApi.globalOption.searchItems({ whId: this.filters.whId, keyword: query }).then(res => {
				this.itemOptions = res.data || []
			})
		},
    searchEditSkus(query) {
      if (!this.filters.whId) return
      this.$wmsApi.globalOption.searchItems({ whId: this.filters.whId, keyword: query }).then(res => {
        this.editSkuOptions = (res.data || []).map(item => ({
          optionValue: item.itemNumber,
          optionDisplay: (item.itemNumber || '') + ' - ' + (item.description || '')
        }))
      })
    },
	findPage: function (data) {
		if(data !== null) {
			this.pageRequest.pageNum = data.pageRequest.pageNum
			this.pageRequest.pageSize = data.pageRequest.pageSize
		}
      let whId=this.filters.whId
      let orderNumber=this.filters.orderNumber
      let itemNumber=this.filters.itemNumber
      this.pageRequest.columnFilters = {whId:{name:'whId',value:whId},orderNumber: {name:'orderNumber', value:orderNumber},itemNumber: {name:'itemNumber', value:itemNumber}}
		this.$wmsApi.tOrderDetail.findPage(this.pageRequest).then((res) => {
			this.pageResult = res.data
		}).then(data!=null?data.callback:'')
	},
	// 批量删除
	handleDelete: function (data) {
		this.$wmsApi.tOrderDetail.batchDelete(data.params).then(data!=null?data.callback:'')
	},
	// 显示新增界面
	handleAdd: function () {
      this.lineNumberVisible = true
	this.editDialogVisible = true
	this.operation = true
	this.dataForm = {
		id: null,
		orderId: null,
		itemMasterId: null,
		whId: null,
		orderNumber: null,
		lineNumber: null,
		itemNumber: null,
		boQty: null,
		boDescription: null,
		boWeight: null,
		qty: null,
		afoPlanQty: null,
		unitPack: null,
		itemWeight: null,
		itemTareWeight: null,
		hazMaterial: null,
		bOLClass: null,
		bOLLine1: null,
		bOLLine2: null,
		bOLLine3: null,
		bOLPlacCode: null,
		bOLPlacDesc: null,
		bOLCode: null,
		qtyShipped: null,
		lineType: null,
		itemDescription: null,
		stackingSeq: null,
		custPart: null,
		lotNumber: null,
		pickingFlow: null,
		unitWeight: null,
		unitVolume: null,
		extendedWeight: null,
		extendedVolume: null,
		overAllocQty: null,
		dateExpected: null,
		orderUom: null,
		hostWaveId: null,
		tranPlanQty: null,
		useShippableUom: null,
		unitInsuranceAmount: null,
		storedAttributeId: null,
		holdReasonId: null,
		originalOrderNumber: null,
		originalLineNumber: null,
		MClientPoNumber: null,
		MReferenceQty: null,
		MCustomerItemNumber: null,
		MVasProfileCode: null,
		MGenericDate1: null,
		MGenericDate2: null,
		MGenericDate3: null,
		MGenericQty1: null,
		MGenericQty2: null,
		MGenericQty3: null,
		MGenericAlloField1: null,
		MGenericAlloField2: null,
		MGenericAlloField3: null,
		MGenericAlloField4: null,
		MGenericAlloField5: null,
		MGenericAlloField6: null,
		MGenericField1: null,
		MGenericField2: null,
		MGenericField3: null,
		MGenericField4: null,
		MGenericField5: null,
		MDynamicField1: null,
		MDynamicField2: null,
		MDynamicField3: null,
		MDynamicField4: null,
		MDynamicField5: null,
		MCreatedBy: null,
		MCreatedDate: null,
		MUpdatedBy: null,
		MUpdatedDate: null,
	}
      this.dataForm.whId=this.filters.whId
      this.dataForm.orderNumber=this.filters.orderNumber
      this.searchEditSkus('')
	},
	// 显示编辑界面
	handleEdit: function (params) {
      this.lineNumberVisible = false
		this.editDialogVisible = true
		this.operation = false
		this.dataForm = Object.assign({}, params.row)
		this.searchEditSkus('')
		this.getItemBaseUom()
	},
    // 保存新增或编辑的数据
    save: function () {
      if(this.lotControl=='N'){
        this.dataForm.lotNumber=null
      }
      let params = Object.assign({}, this.dataForm)
      this.$wmsApi.tOrderDetail.save(params).then((res) => {
        if(res.code == 200) {
          if(res.data == 0) {
            this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAllowEditAndAdd"), type: 'error'})
          } else {
            this.$message({message: this.$t("common.message.success") + '', type: 'success'})
			// this.editLoading = false
			this.$refs['dataForm'].resetFields()
			this.editDialogVisible = false
			this.findPage(null)
          }
        } else {
          this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
        }
        
      })
    },
	// 编辑
	submitForm: function () {
		this.$refs.dataForm.validate((valid) => {
			if (valid) {
				this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
		if (this.lineNumberVisible) {
			let params = Object.assign({}, this.dataForm)
			this.$wmsApi.tOrderDetail.findDuplicateLine(params).then((res) => {
			if (res.code == 200) {
				if (JSON.stringify(res.data) !== '{}' && res.data!==null) {
				this.$message({
					message: this.$t("common.message.fail") + this.$t("common.message.duplicateLine"),
					type: 'error'
				})
				return
				}

				this.callSaveOrStoredAttributeId()
			} else {
				this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				return
			}
			})
		} else {
			this.callSaveOrStoredAttributeId()
		}
				})
			}
		})
	},
	//获取原因下拉列表
	getReason: function (){
		let whId = this.dataForm.whId
		let clientCode = this.clientCode
		let type='HOLD'

		let objReq = {whId:whId,clientCode:clientCode,type:type}
		this.$wmsApi.globalOption.getReason(objReq)
		.then(res =>
		{
			//请求返回的数据
			this.reasonData = res.data
		})
	},
	// 时间格式化
	dateFormat: function (row, column, cellValue, index){
		return format(row[column.property])
		}
	},
	activated: function () {
		// 兜底：如果 route query 为空，从 sessionStorage 恢复
		if (!this.$route.query.whId && !this.$route.query.orderNumber && sessionStorage.getItem('tod_whId')) {
			this.filters.whId = sessionStorage.getItem('tod_whId')
			this.filters.orderNumber = sessionStorage.getItem('tod_orderNumber')
			this.findPage(null)
		} else if (this.$route.query.whId || this.$route.query.orderNumber) {
			this.getParentParams()
		}
	},
	mounted() {
	}
}
</script>

<style scoped>
/* 商品编码下拉框显示箭头图标 */
.sku-select.el-select.is-focused .el-select__caret {
  opacity: 1 !important;
  transform: rotateZ(180deg);
  color: #c0c4cc;
  font-size: 14px;
}

/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TOrderDetail.vue